import React, { Component } from "react";
import { connect } from "react-redux";
import SchoolItem from "../../components/School/SchoolItem";
import SchoolHeader from "../../components/School/SchoolHeader";
import SchoolKeySearch from "./components/SchoolKeySearch";
import SearchBox from "../../components/Search/SearchBox";
import SchoolFilter from "../../components/School/SchoolFilter";
import Loading from "../../components/Loading";
import ReturnTop from "../../components/ReturnTop";
import ListErrorPrompt from "../../components/ListErrorPrompt";
import { actions as schoolFilterActions } from "../../redux/modules/schoolfilter";
import { post, get } from "../../utils/request";
import "./style.css";
var finished = true;
/**
 * 神奇大学院校的列表组件
 */
class School extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      data: null,
      dataList: [],
      filterVisible: false,
      searchVisible: true,
      dataListVisible: true,
      topVisible: false,
      headerVisible: true,
      headerNum: null,
      filterData: null,
      params: {
        schoolName: "",
        schoolLevelIds: [],
        schoolTagIds: [],
        schoolPropertyIds: [],
        provinceIds: [],
        pageNum: 1,
        pageSize: 20,
      },
    };
    this.removeListener = false;
  }

  render() {
    const { data, dataList, filterVisible, filterData } = this.state;
    return (
      <div ref={this.myRef}>
        <SearchBox
          handleCloseDataList={this.handleCloseDataList}
          handleVisibleFilter={this.handleVisibleFilter}
          placeholder="请输入要查询的大学"
          visible={this.state.searchVisible}
          handleVisibleSearch={this.handleVisibleSearch}
          name={this.props.schoolQuery.schoolName}
        ></SearchBox>
        <SchoolKeySearch
          visible={!this.state.searchVisible}
          requestSchoolList={this.requestSchoolList.bind(this)}
          requestFilterSchoolList={this.requestFilterSchoolList.bind(this)}
          handleKeyChangeParams={this.handleKeyChangeParams.bind(this)}
          handleVisibleSearch={this.handleVisibleSearch}
          handleAddScroll={this.handleAddScroll}
          handleShowDataList={this.handleShowDataList}
          handleResetHeaderNum={this.handleResetHeaderNum}
          placeholder="请输入要查询的大学"
        ></SchoolKeySearch>
        <SchoolHeader
          num={this.state.headerNum}
          visible={this.state.headerVisible}
        ></SchoolHeader>
        {filterData != null ? (
          <SchoolFilter
            visible={filterVisible}
            filterData={filterData}
            handleAddScroll={this.handleAddScroll}
            handleVisibleFilter={this.handleVisibleFilter}
            requestFilterSchoolList={this.requestFilterSchoolList.bind(this)}
            handleChangeParams={this.handleChangeParams.bind(this)}
          ></SchoolFilter>
        ) : (
          ""
        )}
        <div style={{ height: 74 }}></div>
        {this.state.headerNum === 0 && this.state.searchVisible === true ? (
          <div>
            <ListErrorPrompt
              imgSrc={require("../../images/school/notice.png")}
              toptext="这里仅展示了在浙江招生的大学"
              bottomtext="什么也没发现，请确保输入正确"
            ></ListErrorPrompt>
          </div>
        ) : (
          ""
        )}
        {data != null ? (
          <div className={this.state.dataListVisible ? "" : "display_none"}>
            {dataList.map((item, index) => {
              return (
                <SchoolItem
                  key={index}
                  item={item}
                  url="/schooldetail/"
                  from="school"
                ></SchoolItem>
              );
            })}
            {this.state.params.pageNum < data.data.pages ? (
              <Loading></Loading>
            ) : (
              <div className="schoolList_shim"></div>
            )}
          </div>
        ) : (
          ""
        )}
        <div className="schoolList_shim"></div>

        <ReturnTop visible={this.state.topVisible}></ReturnTop>
      </div>
    );
  }
  componentWillMount() {
    this.requestShareConfig();
  }
  /**
   * 在第一次渲染后调用
   */
  componentDidMount() {
    setTimeout(() => {
      const { dispatch } = this.props;
      dispatch(schoolFilterActions.setLevelFilterId([]));
      dispatch(schoolFilterActions.setTagFilterId([]));
      dispatch(schoolFilterActions.setPropertyFilterId([]));
      dispatch(schoolFilterActions.setProvinceFilterId([]));
      dispatch(schoolFilterActions.setLevelMarkArray([]));
      dispatch(schoolFilterActions.setTagMarkArray([]));
      dispatch(schoolFilterActions.setPropertyMarkArray([]));
      dispatch(schoolFilterActions.setProvinceMarkArray([]));
      this.requestSchoolList();
      this.requestSchoolFilter();
      this.handleAddScroll();
      document.title = "浙考之家-神奇大学";
    }, 100);
  }
  /**
   * 请求分享的配置
   */
  requestShareConfig = () => {
    const url = window.location.href;
    get("/api/share/config?url=" + url).then((res) => {
      if (res.status === "success") {
        let signature = res.data.signature;
        let timestamp = res.data.timestamp;
        let noncestr = res.data.nonceStr;
        let appid = res.data.appId;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有public/v1的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appid, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: noncestr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表
        });

        window.wx.ready(function () {
          //分享给朋友
          window.wx.onMenuShareAppMessage({
            title: "浙考之家-神奇大学", // 分享标题
            desc: "一站式升学、就业规划，找浙考之家", // 分享描述
            link: url, // 分享.链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
              //                 alert("OK");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              //                 alert("fail");
            },
          });
          //分享给朋友圈
          window.wx.onMenuShareTimeline({
            title: "浙考之家-神奇大学", // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
          });
        });
      }
    });
  };

  componentDidUpdate() {
    setTimeout(() => {
      if (
        this.state.params.pageNum >= this.state.data.data.pages &&
        !this.removeListener
      ) {
        document.removeEventListener("scroll", this.handleScroll);
        this.removeListener = true;
      }
    }, 500);
  }

  componentWillUnmount() {
    if (!this.removeListener) {
      document.removeEventListener("scroll", this.handleScroll);
    }
  }
  /**
   *控制侧边栏条件过滤框的关闭和展示
   */
  handleVisibleFilter = () => {
    this.setState({
      ...this.state,
      filterVisible: !this.state.filterVisible,
    });
  };
  /**
   * 控制搜索框显示和关闭
   */
  handleVisibleSearch = () => {
    this.setState({
      ...this.state,
      searchVisible: !this.state.searchVisible,
    });
  };
  /**
   * 显示列表
   */
  handleShowDataList = () => {
    this.setState({
      dataListVisible: true,
      headerVisible: true,
    });
  };
  /**
   * 隐藏列表
   */
  handleCloseDataList = () => {
    this.setState({
      dataListVisible: false,
      dataList: [],
      headerVisible: false,
    });
  };
  /**
   * 重置顶部栏目查询的院校的数字
   */
  handleResetHeaderNum = () => {
    this.setState({
      headerNum: null,
    });
  };
  /**
   * 院校过滤组件修改院校的请求参数
   */
  handleChangeParams(params) {
    this.setState({
      ...this.state,
      params: {
        ...this.state.params,
        schoolLevelIds: params.schoolLevelIds,
        schoolTagIds: params.schoolTagIds,
        schoolPropertyIds: params.schoolPropertyIds,
        provinceIds: params.provinceIds,
        pageNum: params.pageNum,
        pageSize: params.pageSize,
      },
    });
  }
  /**
   * 院校搜索组件修改院校的请求参数
   * @param {参数} params
   */
  handleKeyChangeParams(params) {
    this.setState({
      ...this.state,
      params: {
        ...this.state.params,
        schoolName: params.schoolName,
        pageNum: params.pageNum,
        pageSize: params.pageSize,
      },
    });
  }
  /**
   * 请求院校列表
   */
  requestSchoolList() {
    let params = {
      schoolName: this.props.schoolQuery.schoolName,
      schoolLevelIds: this.props.schoolFilter.levelFilterId,
      schoolTagIds: this.props.schoolFilter.tagFilterId,
      schoolPropertyIds: this.props.schoolFilter.propertyFilterId,
      provinceIds: this.props.schoolFilter.provinceFilterId,
      pageNum: this.state.params.pageNum,
      pageSize: this.state.params.pageSize,
    };
    post("/public/v1/school/list", params).then((data) => {
      const newDataList = this.state.dataList.concat(data.data.list);
      this.setState({
        data: data,
        dataList: newDataList,
      });
      finished = true;
    });
  }
  /**
   * 请求院校的过滤条件
   */
  requestSchoolFilter() {
    get("/public/v1/school/filter/0").then((res) => {
      this.setState({
        filterData: res.data,
      });
    });
  }
  /**
   * 在搜索院校以及点击侧边栏搜索过滤条件的时候使用
   */
  requestFilterSchoolList() {
    let params = {
      schoolName: this.props.schoolQuery.schoolName,
      schoolLevelIds: this.props.schoolFilter.levelFilterId,
      schoolTagIds: this.props.schoolFilter.tagFilterId,
      schoolPropertyIds: this.props.schoolFilter.propertyFilterId,
      provinceIds: this.props.schoolFilter.provinceFilterId,
      pageNum: 1,
      pageSize: 20,
    };
    post("/public/v1/school/list", params).then((data) => {
      const newDataList = data.data.list;
      this.setState({
        data: data,
        dataList: newDataList,
        headerNum: data.data.total,
      });
      finished = true;
    });
  }
  /**
   * 添加scroll事件监听
   */
  handleAddScroll = () => {
    document.addEventListener("scroll", this.handleScroll);
  };
  // 处理屏幕滚动事件，实现加载更多的效果
  handleScroll = () => {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const screenHeight = document.documentElement.clientHeight;
    const schoolListTop = this.myRef.current.offsetTop;
    const schoolListHeight = this.myRef.current.offsetHeight;
    if (
      finished &&
      scrollTop >= schoolListHeight + schoolListTop - screenHeight - 2
    ) {
      finished = false;
      setTimeout(() => {
        this.setState({
          params: {
            ...this.state.params,
            pageNum: this.state.params.pageNum + 1,
          },
        });
        this.requestSchoolList();
      }, 500);
    }
    if (scrollTop >= 1200) {
      this.setState({
        topVisible: true,
      });
    } else {
      this.setState({
        topVisible: false,
      });
    }
  };
}
const mapStateToProps = (state) => {
  return {
    schoolFilter: state.schoolfilter.schoolFilterData,
    schoolQuery: state.schoolfilter.schoolQueryData,
  };
};
export default connect(mapStateToProps)(School);



// WEBPACK FOOTER //
// ./src/containers/School/index.js